import React from 'react';
import {Suggestions} from 'components';

export function NegativeEmotions(props) {
  return (
    <Suggestions.List {...props}>
      <p>Fear from failure</p>
      <p>Fear from the unknown</p>
      <p>Insecurity</p>
      <p>Anger</p>
      <p>Shame</p>
      <p>Regret</p>
      <p>Hostility</p>
      <p>Sadness</p>
      <p>Despair</p>
      <p>Nervousness</p>
      <p>Hopelessness</p>
      <p>Life is not fair</p>
      <p>I am lost</p>
    </Suggestions.List>
  );
}
